import React, { ReactElement } from 'react';
import FormatService from '../../services/format-service';
import useStylesControlButtonContainer from './control-button-container.styles';

const ControlButtonContainer: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isCentered,
    isInvisible,
    withTopOffset,
    withLargeTopOffset,
    children,
  } = props;

  const { classes } = useStylesControlButtonContainer();

  const centeredClassName: string | undefined = isCentered ? classes.controlButtonContainerCentered : undefined;
  const invisibleClassName: string | undefined = isInvisible ? classes.controlButtonContainerInvisible : undefined;
  const topOffsetClassName: string | undefined = withTopOffset ? classes.controlButtonContainerTopOffset : undefined;
  const largeTopOffsetClassName: string | undefined = withLargeTopOffset
    ? classes.controlButtonContainerLargeTopOffset : undefined;

  return (
    <div
      className={FormatService.formatClassNames(
        classes.controlButtonContainer, centeredClassName, invisibleClassName, topOffsetClassName,
        largeTopOffsetClassName,
      )}
    >
      {children}
    </div>
  );
});

export default ControlButtonContainer;
